export const OrderStatus = {
  NEW: 'new',
  BOOKED: 'booked',
  DELIVERED: 'delivered',
  INTRANSIT: 'intransit',
  CANCELLED: 'cancelled',
  QUOTED: 'quoted',
  SAVED: 'saved',
  INVOICED: 'invoiced',
};
